import { palette } from '@livable/saas-react-components';
const MuiButton = {
  styleOverrides: {
    root: {
      fontFamily: palette.fontFamilies.poppins,
      fontWeight: 600,
      fontSize: '18px',
      lineHeight: '20px',
      padding: '14px 16px',
      boxShadow: 'none',
      textTransform: 'none',
      whiteSpace: 'nowrap',
      '& + .MuiButton-root': {
        // marginLeft: '10px',
      },
      '&:hover': {
        boxShadow: palette.shadows.mid
      },
      '&.Mui-disabled': {
        backgroundColor: palette.shades[300],
        color: palette.common.white
      }
    },
    text: {
      backgroundColor: palette.shades[100],
      boxShadow: palette.shadows.light,
      transition: "background-color ".concat(palette.transitions.short),
      '&:hover': {
        backgroundColor: palette.shades[300],
        color: palette.primary.dark,
        boxShadow: palette.shadows.light
      },
      '& + .MuiButton-contained': {
        marginLeft: '10px'
      }
    },
    contained: {
      '& + .MuiButton-text': {
        marginLeft: '10px'
      },
      '& + .MuiButton-contained': {
        marginLeft: '10px'
      }
    },
    sizeSmall: {
      fontSize: '13px',
      lineHeight: '16px',
      padding: '10px 16px'
    }
  },
  variants: [{
    props: {
      variant: 'priority'
    },
    style: {
      background: 'linear-gradient(90deg, #00767C 0%, #009299 50%, #00B488 100%)',
      backgroundPosition: 'right center',
      backgroundSize: '200% auto',
      boxShadow: palette.shadows.light,
      transition: "all ".concat(palette.transitions.short),
      color: palette.common.white,
      zIndex: '1',
      '&:hover': {
        backgroundPosition: 'left center',
        boxShadow: palette.shadows.hard
      },
      '&:disabled': {
        boxShadow: 'none',
        background: palette.shades[400],
        color: palette.common.white
      }
    }
  }, {
    props: {
      variant: 'huge'
    },
    style: {
      boxShadow: 'none',
      fontSize: '15px',
      lineHeight: '20px',
      textAlign: 'center',
      padding: '18px 0',
      backgroundColor: palette.shades[200],
      color: palette.primary.main,
      width: '100%',
      borderRadius: '0',
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: palette.shades[300],
        color: palette.primary.dark
      }
    }
  }, {
    props: {
      variant: 'action'
    },
    style: {
      background: palette.shades[100],
      position: 'relative',
      borderRadius: '2px',
      display: 'inline-flex',
      boxShadow: palette.shadows.light,
      fontSize: '13px',
      lineHeight: '19.5px',
      padding: '12px 16px',
      width: '248px',
      minWidth: '240px',
      color: palette.shades[800],
      justifyContent: 'left',
      transition: "all ".concat(palette.transitions.short),
      zIndex: '10',
      '.MuiSvgIcon-root': {
        marginRight: '10px',
        path: {
          fill: palette.shades[600],
          transition: "fill ".concat(palette.transitions.short)
        }
      },
      '& + &': {
        marginLeft: '10px'
      },
      '&:hover': {
        color: palette.shades[100],
        boxShadow: palette.shadows.mid,
        background: palette.primary.main,
        '.MuiSvgIcon-root path': {
          fill: palette.shades[100]
        }
      },
      '&.Mui-focusVisible': {
        color: palette.shades[100],
        background: palette.primary.main,
        boxShadow: palette.shadows.light,
        '.MuiSvgIcon-root path': {
          fill: palette.shades[100]
        }
      },
      '& .button-text': {
        flexGrow: '1',
        textAlign: 'left',
        '& + .MuiSvgIcon-root': {
          marginRight: '0'
        }
      }
    }
  }, {
    props: {
      variant: 'menuAction'
    },
    style: {
      backgroundColor: palette.shades[100],
      width: '100%',
      display: 'flex',
      fontSize: '13px',
      lineHeight: '16px',
      padding: '12px 16px',
      color: palette.shades[800],
      justifyContent: 'left',
      borderRadius: '0',
      '.MuiSvgIcon-root': {
        marginRight: '10px',
        path: {
          fill: palette.shades[500],
          transition: "fill ".concat(palette.transitions.short)
        }
      },
      '&:hover': {
        backgroundColor: palette.shades[300],
        boxShadow: 'none',
        '.MuiSvgIcon-root path': {
          fill: palette.shades[700]
        }
      },
      '&.Mui-focusVisible': {
        '.MuiSvgIcon-root path': {
          fill: palette.shades[700]
        }
      }
    }
  }, {
    props: {
      variant: 'actionIcon'
    },
    style: {
      padding: '6px',
      fontSize: '15px',
      lineHeight: '20px',
      backgroundColor: palette.shades[200],
      minWidth: 'initial',
      transition: "all ".concat(palette.transitions.short),
      border: "1px solid ".concat(palette.shades[300]),
      '& .actionText': {
        marginLeft: '6px'
      },
      '& path': {
        fill: palette.shades[700]
      },
      '& + .MuiButton-actionIcon': {
        marginLeft: '10px'
      },
      '&:hover': {
        backgroundColor: palette.shades[300],
        boxShadow: 'none',
        '& path': {
          fill: palette.shades[800]
        }
      },
      '&.MuiButton-actionIconSuccess': {
        '& path': {
          fill: palette.success.main
        },
        '&:hover path': {
          fill: palette.success.main
        }
      },
      '&.MuiButton-actionIconWarning': {
        '& path': {
          fill: palette.warning.main
        },
        '&:hover path': {
          fill: palette.warning.main
        }
      },
      '&.MuiButton-actionIconInfo': {
        '& path': {
          fill: palette.info.main
        },
        '&:hover path': {
          fill: palette.info.main
        }
      },
      '&.MuiButton-actionIconError': {
        '& path': {
          fill: palette.error.main
        },
        '&:hover path': {
          fill: palette.error.main
        }
      },
      '&.MuiButton-sizeHuge': {
        padding: '12px',
        width: '48px',
        height: '48px'
      },
      '&.MuiButton-sizeLarge': {
        padding: '8px',
        '& .MuiSvgIcon-root': {
          width: '32px',
          height: '32px'
        }
      },
      '&.MuiButton-sizeSmall': {
        width: '36px',
        height: '36px'
      },
      '&.Mui-disabled': {
        backgroundColor: palette.shades[200],
        '& path': {
          fill: palette.shades[500]
        }
      }
    }
  }, {
    props: {
      variant: 'actionButton'
    },
    style: {
      padding: '6px 8px 6px 8px',
      backgroundColor: palette.shades[200],
      fontSize: '13px',
      lineHeight: '16px',
      minHeight: '36px',
      color: palette.shades[800],
      '& .actionText': {
        margin: '0 4px'
      },
      '& path': {
        fill: palette.shades[700]
      },
      '& + .MuiButton-actionButton': {
        marginLeft: '10px'
      },
      '&:hover': {
        backgroundColor: palette.shades[300],
        boxShadow: 'none',
        '& path': {
          fill: palette.shades[700]
        }
      },
      '&.Mui-disabled': {
        '& path': {
          fill: palette.shades[500]
        }
      }
    }
  }, {
    props: {
      variant: 'actionButtonInvert'
    },
    style: {
      padding: '6px 8px 6px 8px',
      backgroundColor: palette.shades[200],
      fontSize: '13px',
      lineHeight: '16px',
      minHeight: '36px',
      color: palette.shades[800],
      border: "1px solid ".concat(palette.shades[300]),
      '& .actionText': {
        margin: '0 4px'
      },
      '& path': {
        fill: palette.shades[700]
      },
      '& + .MuiButton-actionButton': {
        marginLeft: '10px'
      },
      '&:hover': {
        backgroundColor: palette.shades[300],
        boxShadow: 'none',
        '& path': {
          fill: palette.shades[700]
        }
      },
      '&.Mui-disabled': {
        '& path': {
          fill: palette.shades[500]
        }
      }
    }
  }, {
    props: {
      variant: 'actionButtonContained'
    },
    style: {
      fontSize: '15px',
      minHeight: '48px',
      color: palette.shades[800],
      padding: '11px 20px 11px 12px',
      backgroundColor: palette.shades[200],
      border: "1px solid ".concat(palette.shades[300]),
      '& .actionText': {
        margin: '0 4px'
      },
      '& .MuiSvgIcon-root': {
        marginRight: '4px'
      },
      '& path': {
        fill: palette.shades[700]
      },
      '& + .MuiButton-actionButton': {
        marginLeft: '10px'
      },
      '&:hover': {
        backgroundColor: palette.shades[300],
        boxShadow: 'none',
        '& path': {
          fill: palette.shades[700]
        }
      },
      '&.Mui-disabled': {
        '& path': {
          fill: palette.shades[500]
        }
      }
    }
  }, {
    props: {
      variant: 'actionButtonPlain'
    },
    style: {
      padding: '10px 18px',
      backgroundColor: palette.shades[200],
      fontSize: '13px',
      lineHeight: '16px',
      height: '36px',
      color: palette.shades[800],
      '& path': {
        fill: palette.shades[700]
      },
      '&:hover': {
        backgroundColor: palette.shades[300],
        boxShadow: 'none',
        '& path': {
          fill: palette.shades[700]
        }
      },
      '&.Mui-disabled': {
        '& path': {
          fill: palette.shades[500]
        }
      }
    }
  }, {
    props: {
      variant: 'utility'
    },
    style: {
      padding: '12px',
      backgroundColor: palette.shades[100],
      width: '48px',
      height: '48px',
      minWidth: 'initial',
      boxShadow: palette.shadows.light,
      '& + .MuiButton-utility': {
        marginLeft: '10px'
      },
      '& path': {
        fill: palette.shades[700]
      },
      '&:hover': {
        boxShadow: palette.shadows.mid,
        backgroundColor: palette.shades[100],
        '& path': {
          fill: palette.shades[800]
        }
      }
    }
  }, {
    props: {
      state: 'active'
    },
    style: {
      backgroundColor: "".concat(palette.primary.main, " !important"),
      color: palette.shades[100],
      '& path': {
        fill: palette.shades[100]
      },
      '&:hover': {
        backgroundColor: palette.primary.main,
        boxShadow: 'none',
        '& path': {
          fill: palette.shades[100]
        }
      }
    }
  }, {
    props: {
      state: 'activeLight'
    },
    style: {
      backgroundColor: palette.success.light,
      '& path': {
        fill: palette.success.main
      },
      '&:hover': {
        backgroundColor: palette.success.light,
        boxShadow: 'none',
        '& path': {
          fill: palette.success.main
        }
      }
    }
  }, {
    props: {
      state: 'info'
    },
    style: {
      backgroundColor: palette.info.light,
      '& path': {
        fill: palette.info.main
      },
      '&:hover': {
        backgroundColor: palette.info.light,
        boxShadow: 'none',
        '& path': {
          fill: palette.info.main
        }
      }
    }
  }, {
    props: {
      state: 'white'
    },
    style: {
      backgroundColor: palette.shades[100],
      '& path': {
        fill: palette.shades[700]
      },
      '&:hover': {
        backgroundColor: palette.shades[300],
        boxShadow: 'none',
        '& path': {
          fill: palette.shades[800]
        }
      }
    }
  }, {
    props: {
      state: 'activePrimary'
    },
    style: {
      background: palette.brandGradients.main,
      boxShadow: palette.shadows.mid,
      '& path': {
        fill: palette.shades[100]
      },
      '&:hover': {
        background: palette.brandGradients.main,
        '& path': {
          fill: palette.shades[100]
        }
      }
    }
  }, {
    props: {
      variant: 'social'
    },
    style: {
      padding: '12px 0',
      width: '180px',
      color: palette.shades[100],
      '.MuiSvgIcon-root': {
        marginRight: '10px',
        path: {
          fill: palette.shades[100]
        }
      },
      '& + .MuiButton-social': {
        marginLeft: '10px'
      }
    }
  }, {
    props: {
      social: 'google'
    },
    style: {
      backgroundColor: palette.socials.google,
      '&:hover': {
        backgroundColor: palette.socials.google
      }
    }
  }, {
    props: {
      social: 'facebook'
    },
    style: {
      backgroundColor: palette.socials.facebook,
      '&:hover': {
        backgroundColor: palette.socials.facebook
      }
    }
  }, {
    props: {
      social: 'apple'
    },
    style: {
      backgroundColor: palette.socials.apple,
      '&:hover': {
        backgroundColor: palette.socials.apple
      }
    }
  }, {
    props: {
      social: 'twitter'
    },
    style: {
      backgroundColor: palette.socials.twitter,
      '&:hover': {
        backgroundColor: palette.socials.twitter
      }
    }
  }, {
    props: {
      social: 'linkedin'
    },
    style: {
      backgroundColor: palette.socials.linkedin,
      '&:hover': {
        backgroundColor: palette.socials.linkedin
      }
    }
  }, {
    props: {
      social: 'microsoft'
    },
    style: {
      backgroundColor: palette.socials.microsoft,
      '&:hover': {
        backgroundColor: palette.socials.microsoft
      }
    }
  }]
};
export default MuiButton;